import { MarketOption } from '../../modules/Questionnaire/MarketVisibility/useProjectMarkets'
import { PanelSupplier } from '../audienceHelper'

export interface MarketExportMeta {
  languages: string[]
  panel: PanelSupplier
}

export interface PreviewLink {
  label: string
  url: string
}

/**
 * Markets whose fieldwork uses `languageCode`. With no language (the master /
 * English export) every market is in scope. Returns the strict match otherwise
 * (possibly empty) — the empty-match fallback is the caller's policy.
 */
export const computeExportMarkets = (
  allMarkets: MarketOption[],
  meta: Map<string, MarketExportMeta>,
  languageCode?: string
): MarketOption[] =>
  languageCode
    ? allMarkets.filter(
        (market) => meta.get(market.surveyId)?.languages.includes(languageCode)
      )
    : allMarkets
